export const STRING = {
  DOT: ".",
  EMPTY: "",
  ZERO: "0",
  COMMA: ",",
  MINUS: "-",
  SPACE: " ",
  SLASH: "/",
  QUOTE: "'",
  QUESTION: "?",
  DOUBLE_QUOTES: "\"",
  INVISIBLE: " ", // &nbsp; нерозривний пробіл
} as const;
